import { render, staticRenderFns } from "./OwnVessel.vue?vue&type=template&id=8006315c&scoped=true&"
import script from "./OwnVessel.vue?vue&type=script&lang=js&"
export * from "./OwnVessel.vue?vue&type=script&lang=js&"
import style0 from "./OwnVessel.vue?vue&type=style&index=0&id=8006315c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8006315c",
  null
  
)

export default component.exports